var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        [
          _vm.indicadorCargaShow
            ? _c("indicador-carga", { attrs: { mensaje: _vm.mensajeCarga } })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c("h3", {
                  staticClass: "title mt-4",
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("apeironGwApp.resumenPagos.title")
                    ),
                  },
                }),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-2" },
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-overlay",
                    {
                      attrs: {
                        show: _vm.isSearching,
                        "spinner-variant": "primary",
                      },
                    },
                    [
                      _c("b-table", {
                        staticClass: "text-nowrap mt-3",
                        attrs: {
                          responsive: "",
                          "sticky-header": "70vh",
                          "show-empty": "",
                          "head-variant": "primary",
                          fields: _vm.campos,
                          items: _vm.pagos,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "empty",
                            fn: function () {
                              return [
                                _c(
                                  "b-row",
                                  { attrs: { "align-h": "center" } },
                                  [
                                    _c("b-col", { attrs: { cols: "4" } }, [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.resumenPagos.mensaje.sinResultados"
                                            )
                                          ),
                                        },
                                      }),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-5", attrs: { "align-v": "center" } },
            [
              _c("b-col", { attrs: { cols: "2", md: "2", offset: "7" } }, [
                _c("span", {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("apeironGwApp.resumenPagos.resumen.totalApoyo")
                    ),
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "text-right", attrs: { cols: "3", md: "3" } },
                [
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.utilidades.formatearMonto(_vm.totalApoyo)) +
                        " M.N"
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "5", lg: "5", offset: "7" } }, [
                _c("hr", { staticClass: "bg-dark" }),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { attrs: { "align-v": "center" } },
            [
              _c("b-col", { attrs: { cols: "2", md: "2", offset: "7" } }, [
                _c("span", {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("apeironGwApp.resumenPagos.resumen.totalGeneral")
                    ),
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "text-right", attrs: { cols: "3", md: "3" } },
                [
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.utilidades.formatearMonto(_vm.totalGeneral)) +
                        " M.N"
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "5", lg: "5", offset: "7" } }, [
                _c("hr", { staticClass: "bg-dark" }),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { attrs: { "align-v": "center" } },
            [
              _c("b-col", { attrs: { cols: "2", md: "2", offset: "7" } }, [
                _c("span", {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t(
                        "apeironGwApp.resumenPagos.resumen.totalModificado"
                      )
                    ),
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "text-right", attrs: { cols: "3", md: "3" } },
                [
                  _c("b", [
                    _vm._v(
                      _vm._s(
                        _vm.utilidades.formatearMonto(_vm.totalModificado)
                      ) + " M.N"
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "5", lg: "5", offset: "7" } }, [
                _c("hr", { staticClass: "bg-dark" }),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }